import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import "./tooltip.script";
export function RuiTooltip({
  children,
  content = "",
  ...props
}) {
  return /* @__PURE__ */jsx("rui-tooltip", {
    content,
    ...props,
    children: /* @__PURE__ */jsxs("span", {
      class: "rui-tooltip",
      children: [/* @__PURE__ */jsx("span", {
        class: "rui-tooltip__trigger",
        children
      }), /* @__PURE__ */jsx("span", {
        class: "rui-tooltip__content rui-floating",
        "data-ref": "tooltip",
        role: "tooltip",
        hidden: true,
        children: content
      })]
    })
  });
}